
import { toast } from "sonner";

// Configure the base URL for the PDF processing API
const PDF_API_URL = "https://everest-pdf-api.onrender.com";

/**
 * Process a PDF file using the backend API
 * @param file PDF file to process
 * @returns Structured data extracted from the PDF
 */
export async function processPdfFile(file: File) {
  try {
    const formData = new FormData();
    formData.append('file', file);

    console.log(`Sending PDF to API: ${file.name} (${Math.round(file.size / 1024)} KB)`);
    
    const response = await fetch(`${PDF_API_URL}/api/process-pdf`, {
      method: 'POST',
      body: formData,
    });

    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(`API Error (${response.status}): ${errorText}`);
    }

    const data = await response.json();
    console.log('PDF processing successful:', data);
    return data;
  } catch (error) {
    console.error('Error processing PDF:', error);
    toast.error(error instanceof Error ? error.message : "Failed to process PDF file");
    throw error;
  }
}

/**
 * Process raw text from a repair estimate (useful for debugging)
 * @param text Raw text to process
 * @returns Structured data extracted from the text
 */
export async function processEstimateText(text: string) {
  try {
    console.log(`Sending text to API (${text.length} characters)`);
    
    const response = await fetch(`${PDF_API_URL}/api/process-text`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ text }),
    });

    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(`API Error (${response.status}): ${errorText}`);
    }

    const data = await response.json();
    console.log('Text processing successful:', data);
    return data;
  } catch (error) {
    console.error('Error processing text:', error);
    toast.error(error instanceof Error ? error.message : "Failed to process text");
    throw error;
  }
}
